import { ButtonBase } from '@mui/material';
import { Stack, styled, Text } from 'shell/components';

const CompactRightVariant = 'compact-right';

const ChatPromptSuggestions = ({ suggestions, disabled, title, variant, onSelect }) => {
    if (!suggestions.length) return null;

    const isCompactRight = variant === CompactRightVariant;

    return (
        <SuggestionsStack isCompactRight={isCompactRight} spacing={2.5}>
            {title ? (
                <Text variant={'p3'} weight={'semibold'} textAlign={isCompactRight ? 'right' : 'left'}>
                    {title}
                </Text>
            ) : null}
            {suggestions.map((suggestion) => (
                <SuggestionRow key={suggestion.text} isCompactRight={isCompactRight}>
                    <SuggestionButton
                        disabled={disabled}
                        isCompactRight={isCompactRight}
                        onClick={() => onSelect(suggestion.text)}
                    >
                        {suggestion.text}
                    </SuggestionButton>
                </SuggestionRow>
            ))}
        </SuggestionsStack>
    );
};

const SuggestionsStack = styled(Stack, {
    shouldForwardProp: (prop) => prop !== 'isCompactRight',
})(({ isCompactRight }) => {
    return {
        width: '330px',
        maxWidth: '100%',
        alignSelf: 'flex-end',
        ...(isCompactRight && {
            alignItems: 'flex-end',
        }),
    };
});

const SuggestionRow = styled('div', {
    shouldForwardProp: (prop) => prop !== 'isCompactRight',
})(({ isCompactRight }) => ({
    display: 'flex',
    justifyContent: isCompactRight ? 'flex-end' : 'flex-start',
    maxWidth: '100%',
    width: '100%',
}));

const SuggestionButton = styled(ButtonBase, {
    shouldForwardProp: (prop) => prop !== 'isCompactRight',
})(({ isCompactRight, theme }) => {
    return {
        border: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        borderRadius: '20px',
        background: 'rgba(255, 255, 255, 0.75)',
        backdropFilter: 'blur(4px)',
        boxShadow: 'none',
        width: 'fit-content',
        maxWidth: '100%',
        flex: '0 1 auto',
        display: 'inline-flex',
        fontFamily: 'inherit',
        fontSize: `${theme.typography.p2.fontSize.large}rem`,
        fontWeight: theme.typography.p3.fontWeight.regular,
        letterSpacing: `${theme.typography.p3.letterSpacing.large}rem`,
        lineHeight: `${theme.typography.getLineHeight('p3', 'large')}rem`,
        padding: theme.spacing(3, 4),
        justifyContent: isCompactRight ? 'flex-end' : 'flex-start',
        textAlign: isCompactRight ? 'right' : 'left',
        whiteSpace: 'normal',
        overflowWrap: 'normal',
        wordBreak: 'normal',

        '&:hover': {
            borderColor: theme.palette.ensightful.primary[500],
        },
        '&:active': {
            borderColor: theme.palette.ensightful.primary[700],
        },
        '&:focus-visible': {
            outline: `${theme.palette.ensightful.secondary[400]} solid 3px`,
            outlineOffset: '4px',
        },
    };
});

export { CompactRightVariant };
export default ChatPromptSuggestions;
